import React, { useEffect, useState } from "react";
import { useAppNavigate } from "utils/router";
import { useLocation } from "react-router-dom";
import { AuthenticationURLs } from "constants/in-app-urls";

const AUTH_SIGNUP_PATH = `/${AuthenticationURLs.CUSTOMER_ANALYTICS_AUTH_SIGN_UP_URL}`;

interface InviteParams {
    userId: string | null;
    userEmail: string | null;
    runtimeId: string | null;
    productId: string | null;
    environmentId: string | null;
    invitePayload: string | null;
    accountId: string | null;
}

const updateInvitedUserState = (_params: InviteParams) => {
    // Placeholder for updating invited user state
};

const Invitation = () => {
    const navigate = useAppNavigate();
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState<string>("");

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);

        const userId = urlParams.get("userId");
        const userEmail = urlParams.get("userEmail");
        const runtimeId = urlParams.get("runtimeId");
        const productId = urlParams.get("productId");
        const environmentId = urlParams.get("environmentId");
        const invitePayload = urlParams.get("invitePayload");
        const accountId = urlParams.get("accountId");

        const params: InviteParams = {
            userId,
            userEmail,
            runtimeId,
            productId,
            environmentId,
            invitePayload,
            accountId
        };

        updateInvitedUserState(params);

        const searchString = location.search || "";
        navigate({
            pathname: AUTH_SIGNUP_PATH,
            search: searchString
        });
    }, [location.search, navigate]);

    if (errorMessage) {
        return (
            <div className="flex h-screen w-full flex-col items-center justify-center px-6 text-center">
                <h1 className="text-xl font-semibold text-gray-900 mb-2">Unable to continue</h1>
                <p className="text-sm text-gray-600 mb-4">{errorMessage}</p>
                <button
                    className="text-indigo-600 font-medium hover:underline"
                    onClick={() => window.location.reload()}
                >
                    Try again
                </button>
            </div>
        );
    }

    return (
        <div className="flex h-screen w-full flex-col items-center justify-center px-6 text-center">
            <p className="text-lg font-medium text-gray-800">Redirecting to sign up...</p>
        </div>
    );
};

export default Invitation;
